import { Stack, StackProps, styled } from "@mui/material";
import { COLORS } from "constants/layout";

interface StyledSupplierProps {
  gradient?: string;
}

export const StyledSupplier = styled(Stack)<StyledSupplierProps & StackProps>(
  ({ theme, gradient }) => ({
    height: "100%",
    position: "relative",
    borderRadius: 8,
    backgroundColor: "#fff",
    border: gradient ? "none" : `1px solid var(--gray-200)`,
    padding: "8px 12px 12px",
    "&::before": gradient
      ? {
          content: '""',
          position: "absolute",
          inset: 0,
          padding: 2,
          borderRadius: "inherit",
          background: `linear-gradient(to right, ${gradient})`,
          WebkitMask:
            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "destination-out",
          maskComposite: "exclude",
          pointerEvents: "none",
        }
      : {},
    "& .medias": {
      width: 250,
      height: 240,
      img: {
        width: "100%",
        height: "100%",
      },
    },
    ".tag-chip": {
      backgroundColor: COLORS.gray[100],
      color: COLORS.gray[700],
    },
    "& .categories": {
      color: "var(--gray)",
      span: {
        color: "var(--gray-900)",
      },
    },
    ".left-box": {
      "& .image": {
        height: 45,
        width: 45,
        objectFit: "cover",
        borderRadius: 8,
      },
      ".categories-text a": {
        color: "var(--green-600)",
      },
    },
    ".avatar": {
      objectFit: "cover",
    },
    ".right-box": {
      ".item-box": {
        overflow: "hidden",
        border: "1px solid var(--gray-200)",
        borderRadius: 8,
        ".item-name": {
          color: "#27272A",
        },
        ".item-img": {
          span: {
            height: "100%",
            width: "100%",
            img: {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          },
        },
        ".min_order_qlt": {
          fontSize: 10,
          span: {
            color: COLORS.gray[800],
            fontWeight: 500,
          },
        },
      },
    },
    ".chat-icon": {
      padding: 0,
      "&:hover": {
        backgroundColor: "var(--green-50)",
      },
    },

    "& .swiper-pagination-bullet-active": {
      backgroundColor: "#ddd",
    },
    ".owner-info": {
      ".avatar": {
        borderRadius: "50%",
      },
      ".left-box": {},
    },

    [theme.breakpoints.down("md")]: {
      padding: "8px",
      ".left-box": {
        maxWidth: "100%",
      },
      "& .image": {},
      "& .send-inquiry-btn": {
        fontSize: 12,
      },
      ".owner-info": {
        ".left-box, .buttons-box": {
          width: "100%",
        },
        ".buttons-box button": {
          padding: "4px 8px",
          lineHeight: "18px",
          svg: {
            width: 15,
            height: 15,
          },
        },
      },
      ".right-box": {
        width: "100%",
        justifyContent: "flex-start",
        ".products": {
          width: "100%",
          justifyContent: "flex-start",
        },
        ".item-box": {
          width: "calc(100% / 3)",
          height: "fit-content",
          img: {
            borderRadius: 4,
            cursor: "pointer",
          },
          span: {
            height: "100%",
          },
          ".item-img": {
            height: "calc(100% - 30px)",
          },
        },
      },
    },
  })
);
